// Caixa aberto? Só no BALCÃO (30/09/2026): venda feita sem caixa aberto não
// entra no caixa na hora, e o caixa só descobria no fechamento. Consulta
// GET /api/caixa/status ao abrir o Balcão e de novo antes de finalizar (ao ir
// para "Como deseja consumir?" e para o pagamento). Não bloqueia a venda: a
// tela só mostra o aviso (components/AvisoCaixaFechado). `null` = ainda não
// sabe ou deu erro de rede — sem aviso.
import axios from "axios";
import { useEffect, useState } from "react";

export function useCaixaAberto({ ativo, screen }) {
  const [aberto, setAberto] = useState(null);
  const momento = screen === "delivery_type" || screen === "payment" ? screen : "venda";
  useEffect(() => {
    if (!ativo) { setAberto(null); return undefined; }
    let vivo = true;
    axios.get("/api/caixa/status", { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } })
      .then(({ data }) => { if (vivo) setAberto(!!data?.id && data.status !== "fechado"); })
      .catch(() => { /* sem rede: fica o que já se sabia */ });
    return () => { vivo = false; };
  }, [ativo, momento]);
  return aberto;
}
